<div class="seg" [class.full]="full" data-aud-seg>
    <button
        *ngFor="let opt of options"
        type="button"
        class="seg-btn"
        [class.active]="opt.value === value"
        (click)="select(opt)"
    >
        {{ opt.label }}
    </button>
</div>
